import { Question } from './questions';
import { useLanguage } from '../context/LanguageContext';
import { useMemo } from 'react';

/**
 * This function returns translated questions using the translation system.
 * It's a hook that must be used inside a component that has access to the language context.
 */
export const useTranslatedQuestions = (): Question[] => {
  const { t } = useLanguage();

  // Memoize the translated questions to prevent infinite re-renders
  return useMemo(() => [
    {
      "id": "handSize",
      "question": t("question.handSize"),
      "helpText": t("question.handSize.help"),
      "options": [
        { "value": "small", "label": t("option.small"), "imageUrl": "/images/small-hand.jpg" },
        { "value": "medium", "label": t("option.medium"), "imageUrl": "/images/medium-hand.jpg" },
        { "value": "large", "label": t("option.large"), "imageUrl": "/images/large-hand.jpg" }
      ]
    },
    {
      "id": "handedness",
      "question": t("question.handedness"),
      "helpText": t("question.handedness.help"),
      "options": [
        { "value": "right", "label": t("option.right"), "imageUrl": "/images/right-hand.jpg" },
        { "value": "left", "label": t("option.left"), "imageUrl": "/images/left-hand.jpg" }
      ]
    },
    {
      "id": "userType",
      "question": t("question.userType"),
      "helpText": t("question.userType.help"),
      "options": [
        { "value": "professional", "label": t("option.professional"), "imageUrl": "/images/professional-user.jpg" },
        { "value": "amateur", "label": t("option.amateur"), "imageUrl": "/images/amateur-user.jpg" }
      ]
    }
  ], [t]); // Only recreate when the translation function changes
}; 